module.exports = __webpack_public_path__ + "static/media/evoBTC.1c1b599c.svg";